export default "__VITE_ASSET__Dwx_eGKO__"